import axios from 'axios';
import apiRequestHeaders from '../apiRequestHeaders';

export function isAvailable(accommodationId: string, start: Date, end: Date) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
    params: { accommodationId, start, end },
  };
  return axios
    .get('/integrations/sportum/sportum/IsAvailable', config)
    .then(res => res.data);
}

export function makebooking(bookingId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post('/integrations/sportum/sportum/makebooking', { bookingId }, config) // Send bookingId as part of the body
    .then(res => {
      return res.data;
    });
}

export function maketempbooking(bookingId) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };
  return axios
    .post(
      '/integrations/sportum/sportum/maketempbooking',
      { bookingId },
      config,
    ) // Send bookingId as part of the body
    .then(res => {
      return res.data;
    });
}

export function fetchavailabilitiesforsingleaccommodation(
  accommodationId: string,
) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
      'Content-Type': 'application/json', // Add this header
    },
  };
  return axios
    .post(
      '/integrations/sportum/sportum/fetchavailabilitiesforsingleaccommodationinbackground',
      JSON.stringify(accommodationId), // Send as JSON string
      config,
    )
    .then(res => {
      return res.data;
    });
}

export function pollJobStatus(jobId: string) {
  const config = {
    headers: {
      ...apiRequestHeaders.csrfHeader(),
      ...apiRequestHeaders.activeSiteHeader(),
    },
  };

  return axios
    .get(
      `/integrations/sportum/sportum/getjobstatus/sportum-availabilities/job-status/${jobId}`,
      config,
    )
    .then(res => res.data);
}
